import { Component } from '@angular/core';
import {
  INTELLECTUAL_PROPERTY_ROUTE,
  COOKIE_POLICY_ROUTE,
  COMPLAINTS_AND_DISPUTES, PERSONAL_DATA_PROTECTION, GENERAL_CONDITIONS_ROUTE
} from "src/app/app-routing.module";

@Component({
    selector: 'app-policies',
    templateUrl: './policies.component.html',
    styleUrl: './policies.component.scss',
    standalone: false
})
export class PoliciesComponent {

  protected readonly GENERAL_CONDITIONS_ROUTE:string = GENERAL_CONDITIONS_ROUTE;
  protected readonly COOKIE_POLICY_ROUTE:string = COOKIE_POLICY_ROUTE;
  protected readonly INTELLECTUAL_PROPERTY_ROUTE:string = INTELLECTUAL_PROPERTY_ROUTE;
  protected readonly COMPLAINTS_AND_DISPUTES:string = COMPLAINTS_AND_DISPUTES;
  protected readonly PERSONAL_DATA_PROTECTION:string = PERSONAL_DATA_PROTECTION;

}
